import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  optionsRow: {
    '&:not(:first-child)': {
      marginTop: 4
    }
  }
})
